/* cp-plus1.js - akcija +1 gratis parfem (SR, 21-30.9.2026). Mirko 17.9.
   Gratis se sam doda kao obican proizvod kad korpa kvalifikuje; na stavci je
   padajuci izbor Muski/Zenski/Unisex; kupac koji ga izbaci ne dobija ga ponovo. */
(function () {
  /* datumska kapija: akcija 21.9 00:01 - 30.9 23:59 (Beograd); pre/posle radi samo uz ?cp_plus1_preview=1 */
  var CP_POCETAK = 0; /* Petar 19.9 20:15: 'Odmah' - start odmah, kraj ostaje 30.9 23:59 */
  var CP_KRAJ = 1790798866000; /* Ivan 30.9 22:08: ugaseno odmah */
  var cpPreview = /[?&]cp_plus1_preview=1/.test(location.search);
  try {
    if (cpPreview) sessionStorage.setItem('cpPlus1Prev', '1');
    if (sessionStorage.getItem('cpPlus1Prev') === '1') cpPreview = true;
  } catch (e) {}
  if (!cpPreview && (Date.now() < CP_POCETAK || Date.now() > CP_KRAJ)) return;

  var VAR = { m: 43348682506334, z: 43348682539102, u: 43348682571870 };
  var IMENA = { 43348682506334: "Men's", 43348682539102: "Women's", 43348682571870: "Unisex" };
  var GRATIS_HANDLE = 'mystery-perfume-1-free-gift';
  var PODRAZUMEVANI = VAR.u;
  var PARFEMI = 'bakar,aventure,wild-bergamot,fiction,spiced-bergamot,luxurious,old-tree,private-beach,avenue-330,secret-garden,irishman-power,existation,tuxedo,aqua-source,million-dreams,african-day,feels-like-summer,in-space,bitter-life,hero,extreme-life,american-dream,golden-ray,super-man,killer-phantom,modern-love,sealover,smooth-jazz,enthusiast,leathery-path,skyfall,pharaoh-ii,been-good-before,freedom,aquaman,blank,hint-of-vanilla,magnificent,athens'.split(',');
  var radim = false;

  function kvalifikuje(item) {
    if (PARFEMI.indexOf(item.handle) !== -1) return true;
    if (item.handle === '3-for-90') return true;
    var t = (item.product_title || '').toLowerCase();
    if (t.indexOf('discovery set') !== -1 && item.final_price > 100) return true;
    return false;
  }
  function jeGratis(item) { return (item.sku || '').indexOf('SKU-PLUS1-') === 0; }

  function osveziPrikaz() {
    if (document.getElementById('CartDrawer')) {
      fetch('/?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
        if (s['cart-drawer']) {
          var doc = new DOMParser().parseFromString(s['cart-drawer'], 'text/html');
          var novi = doc.getElementById('CartDrawer');
          var stari = document.getElementById('CartDrawer');
          if (novi && stari) stari.innerHTML = novi.innerHTML;
        }
        var b = document.getElementById('cart-icon-bubble');
        if (b && s['cart-icon-bubble']) b.innerHTML = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').body.innerHTML;
        setTimeout(doteraj, 150);
      }).catch(function () {});
    }
    if (location.pathname.replace(/\/$/, '') === '/cart') { location.reload(); }
  }

  var proslo = { gratis: false, kval: false, n: -1 };
  function sprovedi() {
    if (radim) return;
    radim = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var gratis = null, kval = false;
      cart.items.forEach(function (i) {
        if (jeGratis(i)) gratis = i;
        else if (kvalifikuje(i)) kval = true;
      });
      var nKom = 0;
      cart.items.forEach(function (i) { if (!jeGratis(i)) nKom += i.quantity; });
      /* 20.9 Petar (isto kao SR pravilo 18.9): gratis se UVEK vraca kad korpa kvalifikuje,
         i posle rucnog izbacivanja */
      try { sessionStorage.removeItem('cpPlus1Ne'); } catch (e) {}
      proslo = { gratis: !!gratis, kval: kval, n: nKom };
      var odbio = false;
      try { odbio = sessionStorage.getItem('cpPlus1Ne') === '1'; } catch (e) {}

      if (kval && !gratis && !odbio) {
        return fetch('/cart/add.js?cpPlus1=1', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: PODRAZUMEVANI, quantity: 1 }) })
          .then(function () { proslo = { gratis: true, kval: true, n: nKom }; radim = false; osveziPrikaz(); });
      }
      if (gratis && !kval) {
        return fetch('/cart/change.js?cpPlus1=1', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: gratis.key, quantity: 0 }) })
          .then(function () { proslo = { gratis: false, kval: false, n: nKom }; radim = false; osveziPrikaz(); });
      }
      if (gratis && gratis.quantity > 1) {
        return fetch('/cart/change.js?cpPlus1=1', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: gratis.key, quantity: 1 }) })
          .then(function () { radim = false; osveziPrikaz(); });
      }
      radim = false;
      doteraj(gratis);
    }).catch(function () { radim = false; });
  }
  window.cpPlus1Enforce = sprovedi;

  function doteraj(gratisItem) {
    var linkovi = document.querySelectorAll('a[href*="' + GRATIS_HANDLE + '"]');
    linkovi.forEach(function (a) {
      var red = a.closest('.cart-item') || a.closest('tr') || a.closest('[id^="CartDrawer-Item"], [id^="CartItem"]');
      if (!red || red.querySelector('.cp-plus1-blok')) return;
      // sakrij kontrole kolicine za gratis red
      red.querySelectorAll('quantity-input, .cart-item__quantity-wrapper, .quantity').forEach(function (q) { q.style.display = 'none'; });
      var sel = document.createElement('select');
      sel.className = 'cp-plus1-select';
      sel.setAttribute('aria-label', "Free perfume category");
      Object.keys(VAR).forEach(function (k) {
        var o = document.createElement('option');
        o.value = VAR[k]; o.textContent = IMENA[VAR[k]];
        sel.appendChild(o);
      });
      var trenutna = null;
      var tekst = red.textContent;
      Object.keys(IMENA).forEach(function (vid) { if (tekst.indexOf(IMENA[vid]) !== -1) trenutna = vid; });
      if (trenutna) sel.value = trenutna;
      sel.addEventListener('change', function () {
        var novi = Number(sel.value);
        sel.disabled = true;
        radim = true;
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var g = cart.items.filter(jeGratis)[0];
          if (!g) return;
          return fetch('/cart/change.js?cpPlus1=1', { method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: g.key, quantity: 0 }) })
            .then(function () {
              return fetch('/cart/add.js?cpPlus1=1', { method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: novi, quantity: 1 }) });
            });
        }).then(function () { radim = false; proslo = { gratis: true, kval: true }; osveziPrikaz(); })
          .catch(function () { radim = false; sel.disabled = false; });
      });
      var blok = document.createElement('div');
      blok.className = 'cp-plus1-blok';
      var lab = document.createElement('div');
      lab.className = 'cp-plus1-lab';
      lab.textContent = "👇 Choose the category of your free perfume:";
      blok.appendChild(lab);
      blok.appendChild(sel);
      var ime = red.querySelector('.cart-item__name') || a;
      ime.parentNode.insertBefore(blok, ime.nextSibling);
      var stil = document.createElement('style');
      stil.textContent = '.cp-plus1-blok{display:block;margin:.6rem 0 .2rem;padding:.6rem .7rem;background:#FFEDE2;border:.15rem solid #AD421A;border-radius:.8rem;max-width:22rem}' +
        '.cp-plus1-lab{font-size:1.15rem;font-weight:700;color:#3a3a3a;margin-bottom:.4rem;line-height:1.25}' +
        '.cp-plus1-select{display:block;width:100%;font-size:1.4rem;font-weight:600;padding:.55rem .7rem;border:.15rem solid #AD421A;border-radius:.6rem;background:#fff;color:#AD421A;cursor:pointer}' +
        '.cart-item:has(a[href*="parfem-iznenadenja"]) quantity-input,' +
        '.cart-item:has(a[href*="parfem-iznenadenja"]) .quantity,' +
        '.cart-item:has(a[href*="parfem-iznenadenja"]) .cart-item__quantity-wrapper quantity-input,' +
        'tr:has(a[href*="parfem-iznenadenja"]) quantity-input,' +
        'tr:has(a[href*="parfem-iznenadenja"]) .quantity,' +
        'tr:has(a[href*="parfem-iznenadenja"]) .cp-qty,' +
        '.cart-item:has(a[href*="parfem-iznenadenja"]) .cp-qty{display:none!important}';
      if (!document.getElementById('cp-plus1-stil')) { stil.id = 'cp-plus1-stil'; document.head.appendChild(stil); }
    });
  }

  // okidaci: svaka cart mutacija sa sajta + ucitavanje stranice
  var stariFetch = window.fetch;
  window.fetch = function () {
    var arg = arguments[0];
    var p = stariFetch.apply(this, arguments);
    try {
      var u = typeof arg === 'string' ? arg : (arg && arg.url) || '';
      if (/\/cart\/(add|change|update|clear)/.test(u) && u.indexOf('cpPlus1') === -1) {
        p.then(function () { setTimeout(sprovedi, 400); });
      }
    } catch (e) {}
    return p;
  };
  function cpStart() { setTimeout(sprovedi, 600); setTimeout(sprovedi, 1600); setTimeout(sprovedi, 3500); }
  setInterval(function cpCuvar() { try { if (document.querySelector('a[href*="' + GRATIS_HANDLE + '"]') && !document.querySelector('.cp-plus1-blok')) sprovedi(); } catch (e) {} }, 4000);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cpStart);
  else cpStart();
})();
